var $b952a1baf8e23a5b$exports = {};
// frontend/js/classIndex.js
// Class index page - displays all available pedagogical sessions
// Helper function to get translation
function $b952a1baf8e23a5b$var$t(key, fallback) {
    if (window.i18n && typeof window.i18n.t === 'function') {
        const result = window.i18n.t(key);
        return result !== key ? result : fallback;
    }
    return fallback;
}
// Get current language
function $b952a1baf8e23a5b$var$getCurrentLang() {
    if (window.i18n && window.i18n.lang) return window.i18n.lang;
    return 'en';
}
async function $b952a1baf8e23a5b$var$loadClasses() {
    const container = document.getElementById('class-list');
    const lang = $b952a1baf8e23a5b$var$getCurrentLang();
    try {
        const res = await fetch(`/api/classes?lang=${lang}`);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const classes = await res.json();
        if (!classes || classes.length === 0) {
            container.innerHTML = `<p style="opacity: 0.7;">${$b952a1baf8e23a5b$var$t('classes.no_classes', 'No classes available yet.')}</p>`;
            return;
        }
        $b952a1baf8e23a5b$var$renderClasses(classes, container);
    } catch (err) {
        console.error('Error loading classes:', err);
        container.innerHTML = `<p style="opacity: 0.7;">${$b952a1baf8e23a5b$var$t('classes.load_error', 'Unable to load classes. Please try again later.')}</p>`;
    }
}
function $b952a1baf8e23a5b$var$renderClasses(classes, container) {
    container.innerHTML = '';
    classes.forEach((cls)=>{
        const card = document.createElement('div');
        card.className = 'class-card';
        card.onclick = ()=>{
            window.location.href = `/classview?id=${cls.id}`;
        };
        const levelLabel = $b952a1baf8e23a5b$var$t('classes.level', 'Level');
        const durationLabel = $b952a1baf8e23a5b$var$t('classes.duration', 'Duration');
        const minLabel = $b952a1baf8e23a5b$var$t('classes.minutes', 'min');
        card.innerHTML = `
      <div class="class-title">${$b952a1baf8e23a5b$var$escapeHtml(cls.title)}</div>
      <div class="class-tagline">${$b952a1baf8e23a5b$var$escapeHtml(cls.tagline || '')}</div>
      <div class="class-meta">
        ${levelLabel}: ${$b952a1baf8e23a5b$var$escapeHtml(cls.level || $b952a1baf8e23a5b$var$t('classes.mixed_level', 'mixed'))}<br>
        ${durationLabel}: ${cls.durationMinutes || 60} ${minLabel}
      </div>
    `;
        container.appendChild(card);
    });
}
// Simple HTML escape function to prevent XSS
function $b952a1baf8e23a5b$var$escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
// Wait for i18n to be ready, then load classes
function $b952a1baf8e23a5b$var$init() {
    if (window.i18n) {
        $b952a1baf8e23a5b$var$loadClasses();
        // Re-render on language change
        document.addEventListener(window.i18n.EVENT_NAME || 'languagechange', $b952a1baf8e23a5b$var$loadClasses);
    } else // Fallback: load without translations
    $b952a1baf8e23a5b$var$loadClasses();
}
// Load classes when page loads
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $b952a1baf8e23a5b$var$init);
else $b952a1baf8e23a5b$var$init();


//# sourceMappingURL=classes.fb06d52c.js.map
